var HEALTH_LABELS = {
  ALL: "All",
  HEALTHY: "Healthy",
  UNHEALTHY: "Unhealthy",
  IDLE: "Idle",
  NA: "N/A"
};

module.exports = HEALTH_LABELS;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/HealthLabels.js